import { render, staticRenderFns } from "./resource-selector.vue?vue&type=template&id=b1cd079c&scoped=true&"
import script from "./resource-selector.vue?vue&type=script&lang=ts&"
export * from "./resource-selector.vue?vue&type=script&lang=ts&"
import style0 from "./resource-selector.vue?vue&type=style&index=0&id=b1cd079c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cd079c",
  null
  
)

export default component.exports